module.exports = __webpack_public_path__ + "img/map.a4e1d246.png";